import File from './File'

export default File
// eslint-disable-next-line import/export
export * from './File'
